module.exports = __webpack_public_path__ + "media/41.a2c1c669.mp3";